<template id="sq-question">
    <div class="type-choose" :responseData="responseData">
      <h4>
        <div class="q-title">
          <div v-if="isContent && subChinese"
          class="q-tit-content chinese-content"
          v-html="qContent">
          </div>
          <div v-else class="q-tit-content" v-katexHtml="htmlDeCode(qContent, 1)">
          </div>
          <div class="audio-wrap">
            <div v-if="hearing_url && audio.playing" class="point point1"></div>
            <div class="audio" v-if="hearing_url"
                 @click="startPlayOrPause">
                <span :class = "['icon',audio.playing ? 'icon-pause':'icon-play']">
                  <span class="path1"></span><span class="path2"></span>
                </span>
              <audio autoplay="true" ref="audio"
                     @pause="onPause"
                     @play="onPlay">
                <source :src="hearing_url" type="audio/mpeg">
              </audio>
            </div>
          </div>
        </div>
        <div v-if="course_type=='V5' && qContentImages.length">
          <img v-for="(item,index) in qContentImages" :key="index" :src="item.source"/>
        </div>
      </h4>
      <div v-if="submit.question_type == 1" class="select-question">
        <div class="choose-item-wrap" >
          <div v-for="(item, index) in qOptions"
               :key="index"
               @click="selQuestion(index)"
               :data="item.key"
               :class = "[current === index ? 'q_sel' : '']">
            <span v-html="htmlDeCode(item.key)+'、'"></span>
            <div v-if="course_type=='V5'" class="rit-answer" >
              <p v-katexHtml="item.content"></p>
              <p
              class="choose-img"
              v-if="course_type=='V5' && item.img_data && item.img_data.length">
                <img
                v-for="(img,index) in item.img_data"
                v-show="img.source!==''" :key="index" :src="img.source">
              </p>
            </div>
            <p v-else class="rit-answer" v-katexHtml="item.answer"></p>
          </div>
        </div>
      </div>
      <div class="tiankong-question">
        <h4>
          <div class="fc-main" id="fc-main">
            <ul class="fillblock-wrap"
            v-show="submit.question_type == 2 || submit.question_type == 3">
              <!-- 填空题 input框 公式编辑器的初始化 -->
              <div v-if="!isCommit">
                <li class="choice-option" v-for="(item, $idx) in questionFillBlocks" :key="$idx">
                  <input-box v-if="subChinese"
                  ref="fillBlocks" @fillInput="fillInput"
                  :inputType="0"
                  :isInputOrMsg="!isCommit"
                  :isHasHover="!isCommit" :content="item.content" :curIndex="$idx"
                  :isChoosed="item.isChoosed"
                  :isRight="item.isRight"
                  :isError="item.isError"
                  :isArt="subChinese"></input-box>
                  <input-box v-else ref="fillBlocks"
                  @fillInput="fillInput"
                  :inputType="submit.right_answer[$idx][0]['input_type']" :isInputOrMsg="!isCommit"
                  :isHasHover="!isCommit"
                  :content="item.content"
                  :curIndex="$idx"
                  :isChoosed="item.isChoosed"
                  :isRight="item.isRight"
                  :isError="item.isError"
                  :isArt="subChinese"></input-box>
                </li>
              </div>
            </ul>
          </div>
        </h4>
      </div>
    </div>
</template>
<script>
/* eslint-disable */
import {
  htmlDecodeByRegExp,
  isString
} from '@/utils/index.js'
import { getSign } from '@/pages/dl-web/utils/verify.js'
import api from '@/pages/dl-web/api/api.js'
import InputBox from './components/InputBox/index.vue'

export default {
  name: 'answerChoose',
  props: ['responseData', 'getFatherQuestion'],
  components: { InputBox },
  data () {
    return {
      subClass: false, // 是否为理科
      subChinese: false,
      course_type: this.$route.query.courseType, // 是否是v5
      qId: '', // 题目id
      qContent: '',
      qContentImages: [], // 题干图片
      isContent: false,
      qOptions: [], // 选择题选项
      qAnswer: null, // 题目答案
      isCommit: false, // 提交状态
      fillBlocks: [],
      questionFillBlocks: [], // 填空题答案
      hearing_url: '',
      submit: {
        tsid: '', // 测试id
        question_id: '', // 答题id
        question_type: 1, // 题目类型 1: 单选题; 2: 填空题
        user_answer: '', // 用户答案
        right_answer: '', // 正确答案
        tag_code: '',
        tag_value: '',
        difficulty: '', // 难度
        start_time: '', // 做题开始时间
        submit_token: '',
        advise_do_question_time: '' // 建议做题时间
      },
      current: '',
      isSubmit: false, // 是否提交,
      loading: null,
      audio: {
        playing: true
      }
    }
  },
  watch: {
    responseData (val) {
      this.initData()
    }
  },
  created () {
    this.loading = this.$loading({
      lock: true,
      text: 'loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  },
  beforeUpdate () {
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData: async function () {
      this.hearing_url = ''
      let res = await this.responseData
      if (res && res !== '') {
        let subject = res.info.subject
        this.loading.close()
        this.isCommit = false
        this.isContent = true
        this.zIndex = 99 // 解决多个公式编辑器层次叠加问题的hack
        this.editorObjs = []
        this.fillBlocks = []
        this.submit.question_id = res.question_info.question_id || ''
        this.qOptions = res.question_info.options || []
        // this.qAnswer = res.question_info.answer.split(';') || []
        this.qAnswer = res.question_info.answer || ''
        this.submit.question_type = res.question_info.question_type
        this.submit.right_answer = res.question_info.answer
        this.submit.tag_code = res.tag_code
        this.submit.tag_value = res.tag_value
        this.submit.difficulty = res.question_info.difficulty
        this.submit.start_time = res.start_time
        this.submit.advise_do_question_time = res.advise_time
        this.submit.submit_token = res.submit_token || ''
        if (this.course_type === 'V5') {
          this.qContent = res.question_info.content.content || ''
          this.hearing_url = res.question_info.content.audio_data[0] || ''
          this.qContentImages = res.question_info.content.img_data || []
        } else {
          this.qContent = res.question_info.content || ''
          this.hearing_url = res.question_info.hearing_url
        }
        if (subject === '物理' || subject === '化学' || subject === '数学') {
          this.subClass = true
        }
        if (subject === '语文' || subject === '英语') {
          this.subChinese = true
        }
        if (this.submit.question_type === 2 || this.submit.question_type === 3) {
          // this.submit.right_answer = JSON.stringify(res.question_info.answer)
          this.initFillBlocks(this.qContent, this.submit.question_id)
        }
      }
    },
    selQuestion: function (index) {
      let el = event.currentTarget
      this.current = index
      this.submit.user_answer = el.getAttribute('data')
    },
    subQuestionJump: async function () {
      let that = this
      that.submit.tsid = that.$route.query.id
      this.submit.right_answer = JSON.stringify(this.submit.right_answer)
      let parms = that.submit
      if (this.submit.question_id === '') {
        this.$toast('题目获取失败，请刷新重试')
        return false
      }
      this.loading = this.$loading({
        lock: true,
        text: 'loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      parms.user_answer = ''
      parms.time_stamp = (new Date()).getTime()
      parms.sign = getSign(parms)
      this.subAnswer(parms) // 我不会直接跳过
    },
    subQuestion: async function () {
      let that = this
      that.submit.tsid = that.$route.query.id
      let parms = that.submit
      if (this.submit.question_id === '') {
        this.$toast('题目获取失败，请刷新重试')
        this.loading.close()
        return false
      }
      if (this.submit.question_type === 2 || this.submit.question_type === 3) {
        // 填空题重新赋值答案
        this.getFillAnswer()
        if (this.submit.user_answer[0] === '' || this.submit.user_answer[0] === undefined) {
          this.$toast('你忘记作答了！不会可以选择“我不会，跳过”')
          return false
        }
        this.submit.right_answer = JSON.stringify(this.submit.right_answer)
        parms.user_answer = JSON.stringify(this.submit.user_answer)
      }
      parms.time_stamp = (new Date()).getTime()
      parms.sign = getSign(parms)
      // console.log(parms)
      if (this.submit.user_answer === '') {
        this.$toast('你忘记作答了！不会可以选择“我不会，跳过”')
      } else {
        this.loading = this.$loading({
          lock: true,
          text: 'loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        // 答案不为空
        this.subAnswer(parms)
      }
    },
    subAnswer: async function (parms) {
      let res
      if (this.course_type === 'V5') {
        res = await api.submitQuestionanswerV5(parms)
      } else {
        res = await api.submitQuestionanswer(parms)
      }
      if (res) {
        if (res.code === 0) {
          this.isCommit = true
          this.emptyData() // 提交成功，重置提交数据
          $('#fc-main>ul').html('')
          this.$emit('getFatherQuestion')
        } else if (res.code === 1002) {
          this.$toast('做题记录已经存在，去报告页')
          console.log(res.msg)
        } else {
          this.loading.close()
          this.$toast('登录信息失效,请重新登录')
          console.log(res.msg)
        }
      }
    },
    emptyData: function () {
      this.current = ''
      this.submit = {
        question_id: '', // 答题id
        question_type: 1, // 题目类型 1: 单选题; 2: 填空题
        user_answer: '', // 用户答案
        right_answer: '', // 正确答案
        tag_code: '',
        tag_value: '',
        difficulty: '', // 难度
        start_time: '', // 做题开始时间
        submit_token: '',
        advise_do_question_time: '' // 建议做题时间
      }
    },
    // 生成填空个数
    initFillBlocks (questionContent, qId) {
      if (this.subChinese) {
        questionContent.replace(/(___\d+___)|(##\$\$##)|(______)/g, (s, i) => {
          this.questionFillBlocks.push({
            id: qId + i,
            content: '',
            text: '',
            isRight: false,
            isError: false,
            isChoosed: false,
            inputType: 0,
            isBack: true,
            backTimes: 0,
            oldValue: ''
          })
        })
      } else {
        let n = 0
        questionContent.replace(/(___\d+___)|(##\$\$##)|(______)/g, (s, i) => {
          this.questionFillBlocks.push({
            id: qId + i,
            content: '',
            text: '',
            isRight: false,
            isError: false,
            isChoosed: false,
            inputType: this.submit.right_answer[n][0]['input_type'],
            isBack: true,
            backTimes: 0,
            oldValue: ''
          })
          n++
        })
      }
    },
    // 输入框填入答案
    fillInput (data, e) {
      this.$set(this.questionFillBlocks[data.index], 'content', data['content'])
      this.$set(this.questionFillBlocks[data.index], 'text', data['content'])
    },
    // 获取填空题答案
    getFillAnswer () {
      let res = []
      this.questionFillBlocks.forEach((block, index) => {
        if (block.inputType === 1 && !this.subChinese) {
          this.$refs.fillBlocks[index].checkCanSubmit()
        }
        res.push(block.content)
      })
      this.submit.user_answer = res
    },
    checkFillAnswerIsChinese (str) {
      // const regx = /^[\u4e00-\u9fa5/]+$/
      const regx = /^[\u4e00-\u9fa5]+$/
      if (isString(str) && regx.test(str)) {
        return true
      }
      return false
    },
    // 转换html字符串
    htmlDeCode (str, type) {
      let res = htmlDecodeByRegExp(str, type)
      return res
    },
    closeLoading: function () {
      this.loading.close()
    },
    play () { // 播放音频
      console.log('播放视频中')
      this.$refs.audio.play()
    },
    pause () { // 暂停音频
      console.log('视频暂替')
      this.$refs.audio.pause()
    },
    onPlay () {
      console.log('视频开始播放了')
      this.audio.playing = true
    },
    onPause () {
      console.log('视频暂停了')
      this.audio.playing = false
    },
    startPlayOrPause () {
      return this.audio.playing ? this.pause() : this.play()
    },
    openFullScreen2 () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
      }, 2000)
    }
  },
  destroyed () {
    this.loading.close()
  }
}
</script>

<style lang="scss" scoped>
  .q-tit-content {.fill-mark{
    position: relative;
    display: inline-block;
    width: 60px;
    text-indent: 0;
    em{
      letter-spacing: 0.5px;
      color: #333;
    }
    i{
      position: absolute;
      left: 16px;
      display: inline-block;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      color: #fff;
      border-radius: 50%;
      background-color: #ccc;
      font-style: normal;
      font-size: 14px;
    }
  }}
.type-choose{
  margin: 48px 24px 0 24px;
  min-height: 75%;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  letter-spacing: 0;
  text-align: justify;
  line-height: 28px;
  .select-question{
    text-align: left;
    .fill-mark{
      position: relative;
      display: inline-block;
      width: 60px;
      text-indent: 0;
      em{
        letter-spacing: 0.5px;
        color: #333;
      }
      i{
        position: absolute;
        left: 16px;
        display: inline-block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #fff;
        border-radius: 50%;
        background-color: #ccc;
        font-style: normal;
        font-size: 14px;
      }
    }
  }
  h4{
    font-weight: 500;
    .q-title{
      .q-tit-content{
        display: inline-block;
        width: calc(100% - 60px);
        .fc-practice-question {
          font-family: PingFang-SC-Regular;
          font-size: 16px;
          color: #333333;
          letter-spacing: 0;
          line-height: 28px;
          text-align: left;
          position: relative;
          .fc-main {
            margin-top: 24px;
            p{
              display: inline-block;
            }
            .input-p {
              display: inline-block;
            }
          }
        }
        .fc-practice-question,
        .fc-analysis {
          width: 800px;
        }
      }
      .audio-wrap{
        position: relative;
        width: 46px;
        height: 46px;
        display: inline-block;
        margin-top: -7px;
        vertical-align: top;
        .point{
          position: absolute;
          border-radius: 50%;
          animation: border 1s .5s linear infinite;
        }
        .point2{
          -webkit-animation-delay: 0.5s;
        }
        .audio{
          position: relative;
          display: inline-block;
          width: 32px;
          height: 32px;
          margin: 7px;
          line-height: 32px;
          text-align: center;
          border-radius: 50% ;
          .icon{
            font-size: 32px;
          }
        }
      }
    }
    img{
      max-width: 100%;
      vertical-align: middle;
    }
  }
  .chinese-content{
    img{
      /*width: 310px!important;*/
      /*height: 234px!important;*/
      max-width: 80%;
      border: 4px solid #fff;
      border-radius: 20px;
      background: #ccc;
    }
  }
  .choose-item-wrap{
    margin-top: 20px;
    div{
      display: flex;
      align-items: center;
      width: 60%;
      margin-bottom: 15px;
      padding: 10px;
      background: #FFFFFF;
      border: 2px solid #F2F2F2;
      border-radius: 4px;
      cursor: pointer;
      .rit-answer{
        display: block;
        width: 100%;
        margin-bottom: 0;
        padding-left: 10px;
        border: none;
        border-left: solid 2px #F2F2F2;
        img{
          max-width: 96%;
          vertical-align: middle;
        }
      }
      .choose-img{
        flex-basis: 90%;
        img{
          max-width: 96%;
        }
      }
    }
    .q_sel{
      border: 2px solid #397CF6;
      .rit-answer{
        border-left: solid 1px #397CF6;
      }
    }
  }
}
.tiankong-question{
  .fill-mark{
    position: relative;
    display: inline-block;
    width: 60px;
    text-indent: 0;
    em{
      letter-spacing: 0.5px;
      color: #333;
    }
    i{
      position: absolute;
      left: 16px;
      display: inline-block;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      color: #fff;
      border-radius: 50%;
      background-color: #ccc;
      font-style: normal;
      font-size: 14px;
    }
  }
  .fillblock-wrap {
    margin-top: 24px;
    list-style: none;
    /*font-size: 0;*/
    p{
      display: inline-block;
    }
    .fillblock {
      position: relative;
      width: 290px;
      height: 60px;
      padding: 10px;
      border: 3px solid #f2f2f2;
      border-radius: 4px;
      box-sizing: border-box;
      margin-bottom: 16px;
      .index {
        position: absolute;
        /*z-index: 999;*/
        vertical-align: top;
        margin-top: 6px;
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #ccc;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 20px;
        text-align: center;
        margin-right: 8px;
      }
      input {
        flex: 1;
        width: 250px;
        height: 100%;
        padding-left: 25px;
        border: none;
        outline: none;
        -webkit-appearance: none;
        font-family: HelveticaNeue;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        text-align: justify;
        line-height: 28px;
        background: #ffffff;
      }
      .answer-editor {
        display: flex;
        align-items: center;
        width: 285px;
        height: 100%;
        padding-left: 30px!important;
        background: rgba(0,0,0,0)!important;
        margin: 0 0 0 auto;
        border: none;
      }
      .right-wrong-icon {
        position: absolute;
        display: block;
        top: 6px;
        right: -20px;
        width: 40px;
        z-index: 998;
        img {
          width: 100%;
        }
      }
    }
    .fillblock.right {
      border: 3px solid #ddd;
    }
    .fillblock.wrong {
      border: 3px solid darkred;
    }
  }
  .flex-between{
    display: flex;
  }
}
@keyframes border{
  from {
    width: 0;
    height: 0;
    top: 50%;
    left: 50%;
    background-color: rgba(57,124,246,1);
  }

  to {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(57,124,246,0.2);
  }
}
</style>
